import { render } from "./CrudEngenheiro.vue?vue&type=template&id=495c41b6"
import script from "./CrudEngenheiro.vue?vue&type=script&lang=ts"
export * from "./CrudEngenheiro.vue?vue&type=script&lang=ts"
script.render = render

export default script